module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "Contents-A"
    }
  })]), _c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _c('div', [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }, [_c('p', {
    staticClass: "ct"
  })]), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Resorting_to_Murder#toc_marker-1"
    }
  }, [_vm._v("Resorting to Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Resorting_to_Murder1#toc_marker-2"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/#toc_marker-3"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Resorting_to_Murder3#toc_marker-4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/Resorting_to_Murder4#toc_marker-5"
    }
  }, [_vm._v("The Adventure of the Devil’s Foot")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder5#toc_marker-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Schoolmaster Abroad")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder6#toc_marker-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Murder!")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder7#toc_marker-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Murder on the Golf Links")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder8#toc_marker-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Finger of Stone")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder9#toc_marker-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vanishing of Mrs Fraser")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder10#toc_marker-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Mystery of the Sand-Hills")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder11#toc_marker-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hazel Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder12#toc_marker-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Razor Edge")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder13#toc_marker-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday Task")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder14#toc_marker-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Posteriori")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder15#toc_marker-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where is Mr Manetot?")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder16#toc_marker-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The House of Screams")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder17#toc_marker-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cousin Once Removed")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder18#toc_marker-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More from this Author")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/Resorting_to_Murder19#toc_marker-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contact Us")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2412ddac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resorting_to_Murder2.vue
// module id = 63
// module chunks = 0